import request from '@/utils/request';

/**
 * 一般登录--包含commissionerRouter除去专员的路由
 * @param {*} data 
 * @returns 
 */
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data
  });
}
/**
 * 专员登录--包含commissionerRouter路由
 * @param {*} data 
 * @returns 
 */
export function proLogin(data) {
  return request({
    url: '/pro/login',
    method: 'post',
    data: data
  });
}
export function viewLogin(data) {
  return request({
    url: '/view/login',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function getCurrentUserInfo() {
  return request({
    url: '/current_user/info',
    method: 'get'
  });
}
export function fetchAppUserList(query) {
  return request({
    url: '/app_users',
    method: 'get',
    params: query
  });
}
export function fetchUserBlackList(query) {
  return request({
    url: '/blacklists',
    method: 'get',
    params: query
  });
}
export function setUserBlackList(data) {
  return request({
    url: '/blacklists',
    method: 'post',
    data: data
  });
}
export function removeUserBlack(data) {
  return request({
    url: '/blacklists',
    method: 'delete',
    data: data
  });
}
export function setUserOfficialList(id) {
  return request({
    url: "/official/users/".concat(id),
    method: 'put'
  });
}
export function fetchUserIdentity(user_id) {
  return request({
    url: "/users/identity/".concat(user_id),
    method: 'get'
  });
}
export function updateUserIdentity(user_id, data) {
  return request({
    url: "/users/identity/".concat(user_id),
    method: 'post',
    data: data
  });
}
export function getRegiestList(data) {
  return request({
    url: '/workers',
    method: 'get',
    params: data
  });
}
export function addRegiestInfo(data) {
  return request({
    url: '/worker',
    method: 'post',
    data: data
  });
}
export function updataRegiestInfo(data, id) {
  return request({
    url: "/worker/".concat(id),
    method: 'patch',
    data: data
  });
}
export function deleteRegiestInfo(id) {
  return request({
    url: "/worker/".concat(id),
    headers: {
      'Access-Control-Allow-Origin': '*'
    },
    method: 'delete'
  });
}
export function getUsersList(data) {
  return request({
    url: '/users',
    method: 'get',
    params: data
  });
}
export function addUserInfo(data) {
  return request({
    url: '/user',
    method: 'post',
    data: data
  });
}
export function updataUserInfo(data, id) {
  return request({
    url: "/user/".concat(id),
    method: 'patch',
    data: data
  });
}
export function deleteUserInfo(id) {
  return request({
    url: "/user/".concat(id),
    method: 'delete'
  });
}
export function getPermissionList() {
  return request({
    url: '/permissions',
    method: 'get'
  });
}